export const ALERT_TITLE = {
  info: 'Инфо',
  success: 'Успешно',
  warning: 'Внимание',
  error: 'Ошибка'
}
